import axios from 'axios';
import IResponse from '../../interfaces/response';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';

interface RoleProps {
	permissions: string;
	children: React.ReactNode;
	isPage?: boolean;
}

const CheckPermission: FC<RoleProps> = ({ permissions = '', children, isPage = false }) => {
	const { permission, setPermissions } = useContext(UserContext);
	const [loading, setLoading] = useState(false);
	let navigate = useNavigate();
	useEffect(() => {
		const fetchRoles = () => {
			try {
				if (!permission && !loading) {
					setLoading(true);
					axios<IResponse<string[]>>({
						url: 'admin/user-permissions/',
						method: 'get',
					}).then(res => {
						if (res.data.success) {
							let response = res.data.data;
							setPermissions(response);
							setLoading(false);
						}
					});
				}
			} catch (error) {
				console.error('Error fetching roles:', error);
				setLoading(false);
			}
		};

		fetchRoles();
	}, [permission]);

	let rolesFilter = permission?.filter(item => item === permissions);
	if (permission && isPage && rolesFilter?.length === 0) {
		navigate('/access');
	}

	return <Box className={`w-full ${Array.isArray(rolesFilter) && rolesFilter?.length !== 0 ? '' : 'hidden'}`}>{children}</Box>;
};

export default CheckPermission;
